/* Copyright(c) 2019 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */
/*
@author:Sanobar Golandaj
@Creation Date:12-09-2019
@Description:UI for (Dashboard) campaign specification
*/

import React, { Component } from "react";
// import Navigation from '../layouts/navPage';
import PublisherNavigation from "../layouts/publisherNavPage";
import Footer from "../layouts/footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import CampaignSpecificationPublisherDashboardDetails from "./campaignSpecificationPublisherDashboardDetails";
// import { Alert } from "antd";//kiran-4746-removing console warning-no used
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";//snehal-task-3766-specification VAPT api call
import { Badge } from 'antd';
import '../publisher/publisherInternalReviewLead.css';
// import { json } from "body-parser";
// const queryString = require("query-string");
// var greeting = "";
// var abmFile = [];
// var suppressionFile = [];
// var execlusionFile = [];
// var otherFile = [];
// var countryArray = [];
// var jobLevelArray = [];
// var jobFunctionArray = [];
// var employeeSizeArray = [];
// var companyRevenueArray = [];//kiran-4746-removing console warning-no used
class CampaignSpecificationPublisherDashboard extends Component {
	constructor() {
		super();
		this.state = {
			campID: "",
			parentCampID: "",
			reallocationID: "",
			pID: "",
			cancelTab: "",
			tab: "", //sunita-task-3104-added for getting tab value
			campaignDetails: [], //sandeep-task-3064 added campaignDetails array
			isLeadUploadButtonDisable: false, //sandeep-task-3064 added isLeadUploadButtonDisable
			button1: false,
			showNotesModal: false,
              campaignNotes: "",
              campaignNotesHistory: [],
              editingNoteId: null,
              editingNoteText: "",
		};
		this.handleBackButtonToDashboard =this.handleBackButtonToDashboard.bind(this);
		this.handleFileDownload = this.handleFileDownload.bind(this);
		this.handleFileShowDownload = this.handleFileShowDownload.bind(this);
		this.handlePDFFileShowDownload = this.handlePDFFileShowDownload.bind(this);
		this.handleLeadUpload = this.handleLeadUpload.bind(this); //sandeep-task-3064-added handleLeadUpload function
		 this.openNotesModal = this.openNotesModal.bind(this);
				this.closeNotesModal = this.closeNotesModal.bind(this);
				this.getCampaignNotes = this.getCampaignNotes.bind(this);
				this.handleNotesChange = this.handleNotesChange.bind(this);
				this.handleSendNotes = this.handleSendNotes.bind(this);
				this.handleDeleteNote = this.handleDeleteNote.bind(this);
				this.handleEditNote = this.handleEditNote.bind(this);
				this.handleEditNoteSave = this.handleEditNoteSave.bind(this);
				this.notesPanelRef = React.createRef();
				this.notesBodyRef = React.createRef();
	}
	//sonali-4032-componentDidMount changed to will mount
	componentWillMount() {
	
		if (!this.props.auth.isAuthenticated) {
			this.props.history.push("/userLogin");
		} else {
				//Sonali-3945-VAPT-accessing parameters from props.location
				var campIDTemp;//sonali-4032--storing campID in temp variable as it is giving error in set state
				if (this.props.location.state !== undefined) {
					const {
						cancelKey,campID,parentCampID,reallocationID,leadkey,tab
					} = this.props.location.state;
					campIDTemp=campID;//sonali-4032--storing campID in temp variable as it is giving error in set state
					this.setState({cancelKey,campID,parentCampID,reallocationID,leadkey,tab,key3:leadkey})
				
				}else if (sessionStorage.getItem("campID") !== undefined) {//sonali-4032--addin session variables
					
					var campID = sessionStorage.getItem("campID");
					var parentCampID = sessionStorage.getItem("parentCampID");
					var reallocationID = sessionStorage.getItem("reallocationID");
					campIDTemp=campID;
					this.setState({campID,parentCampID,reallocationID})
				  } else {
					if (sessionStorage.getItem("parentCampID") === undefined) {
					  sessionStorage.clear();
					}
				  }
				//Sonali-4032-commenting below code
			//var parsed = queryString.parse(this.props.location.search);
			// var campID = this.props.location.state.campID;//Sonali-3945-VAPT-accessing parameters from props.location
			// var cancelTab = this.props.location.state.cancelKey;//Sonali-3945-VAPT-accessing parameters from props.location
			// var parentCampID = this.props.location.state.parentCampID;//Sonali-3945-VAPT-accessing parameters from props.location
			// var reallocationID = this.props.location.state.reallocationID;//Sonali-3945-VAPT-accessing parameters from props.location
			// //shivani-task 3204 - passed this key to url for camp spec page back button when user will redirected from publisherDeliverLead .
			// var key3 = this.props.location.state.leadkey;//Sonali-3945-VAPT-accessing parameters from props.location
			// this.setState({ key3: key3 });
			// 	//Sonali-3945-VAPT-accessing parameters from props.location
			// 	var tab = this.props.location.state.tab; //sandeep-task-3064-getting tab value form url
		
			const {  user } = this.props.auth; //kiran-4746-removing console warning-no used
			var pID = user.id;
			
			this.setState({  pID }); //sunita-task-3104-added for getting updated value
			let isLeadUploadButtonDisable = false; //sunita-task-3104-used this variable for disabling or enabling the upload lead button
			let data = { campID: campIDTemp//Sonali-4032-setting campIDTemp to campID
				//pID: pID 
			}; //sunita-task-3104-pass data as per BE requirement.
		
			//sonali-3945-removing pID from above data
			fetch("agencyCreativeReviewBE/checkCreativeApproval", {
				//sunita-task-3104-as per requirement called this api for getting values required for upload lead button
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(data),
			})
				.then((res) => res.json())
				.then((campaignDetails) => {
				
					//sunita-task-3104-below all conditions used for enabling or disabling the upload lead button
					if (
						campaignDetails[0].status === "LP_Pending" &&
						campaignDetails[0].isApproveCreative === false &&
						campaignDetails[0].campaignStatus !== "Cancel Campaign"
					) {
						isLeadUploadButtonDisable = true;
					} else if (
						campaignDetails[0].status === "Accept" &&
						campaignDetails[0].isApproveCreative === true &&
						campaignDetails[0].campaignStatus !== "Cancel Campaign"
					) {
						isLeadUploadButtonDisable = false;
					}
					//shivani-task 3162- to make lead upload button disabled when there is  no creative upload and approved.
					/* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
					else if (
						campaignDetails[0].creativeApprovalRequiredFor === "Advertiser" &&
						campaignDetails[0].marketingChannel === "Email & Telemarketing" &&
						campaignDetails[0].status === "Cancel" &&
						campaignDetails[0].isApproveCreative === false &&
						campaignDetails[0].campaignStatus !== "Cancel Campaign"
					) {
						isLeadUploadButtonDisable = true;
					} else if (
						/* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
						campaignDetails[0].creativeApprovalRequiredFor === "Agency" &&
						campaignDetails[0].marketingChannel === "Email & Telemarketing" &&
						campaignDetails[0].status === "Cancel" &&
						campaignDetails[0].isApproveCreative === false &&
						campaignDetails[0].campaignStatus !== "Cancel Campaign"
					) {
						isLeadUploadButtonDisable = true;
					} else {
						//Aman-5037 added condtion to enable button for allocating the Completed campaign to live 
						if (
							campaignDetails[0].campaignStatus === "Active" &&
							campaignDetails[0].isApproveCreative === true
						) {
							isLeadUploadButtonDisable = false;
						}else{
						//sunita-task-3358- uncommented the below condition-as it's failing for normal campaign when i created the campaign without channel,call audit and creative.
						isLeadUploadButtonDisable = true; //shivani-task 3162- Commented this to make button enable for normal campaigns( without selecting any creative approvals) & both the conditions as mentioned above are working....
						}
					}

					this.setState({
						campaignDetails: campaignDetails,
						isLeadUploadButtonDisable,
					}); //sunita-task-3104 -for getting updated values.
				});

			this.setState({
				pID: pID,
				parentCampID: parentCampID,
				reallocationID: reallocationID,
			});

		//Sonali-4065-passing the campID Temp as campID is undefined
				// fetch("campaign/CampaignDetails?campID=" + campIDTemp)
			// 	.then((res) => res.json())
			// 	.then((campaignDetails) => {
			// 		this.setState({ campaignName: campaignDetails[0].campaignName });
			// 	})
			// 	.catch(function (err) {
			// 		console.log(err);
			// 	});
				const resolvedCampID = campIDTemp || (this.props.location.state && this.props.location.state.campID) || sessionStorage.getItem("campID");
				if (resolvedCampID) {
					fetch("campaign/CampaignDetails?campID=" + resolvedCampID)
					.then((res) => res.json())
					.then((campaignDetails) => {
					  this.setState(
						{
						  campaignName: campaignDetails[0] && campaignDetails[0].campaignName,
						  campID: resolvedCampID,
						},
						() => {
						  //  Fetch notes immediately after setting campID
						  this.getCampaignNotes();
						},
					  );
					})
					.catch(function (err) {
					  console.log(err);
					});
				} else {
					console.warn("Campaign ID not resolved for campaign details and notes.");
				}
			}
		}

	componentDidMount() {
		const campID = this.state.campID || (this.props.location.state && this.props.location.state.campID) || sessionStorage.getItem("campID");
		if (campID) {
			this.setState({ campID }, () => {
				this.getCampaignNotes();
			});
		}
	}

	//Kiran-5958-Added helper methods for internal campaign notes
	computeInitials = (text = "") => {
	  if (!text) return "";
	  return text
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((segment) => segment.charAt(0).toUpperCase())
		.join("");
	};

	getUserDisplayDetails = () => {
	  const authUser = (this.props.auth && this.props.auth.user) || {};
	  const nameFromProfile = [authUser.firstName, authUser.lastName]
		.filter(Boolean)
		.join(" ")
		.trim();
	  const fallbackName = authUser.userName || authUser.email || "Internal User";
	  const displayName = nameFromProfile || fallbackName || "Internal User";
	  return {
		name: displayName,
		initials: this.computeInitials(displayName),
	  };
	};

	resolveNoteUserMeta = (note) => {
	  const fallbackMeta = this.getUserDisplayDetails();
	  if (!note) return fallbackMeta;
	  const senderFullName = note.sender_full_name && note.sender_full_name.trim();
	  const senderName = senderFullName || note.sender_name || note.userName || note.createdBy || note.ownerName;
	  const sanitizedName = senderName && senderName.trim() ? senderName.trim() : fallbackMeta.name;
	  const initials = note.userInitials || note.sender_initials || this.computeInitials(sanitizedName);
	  return { name: sanitizedName, initials };
	};

	formatTimestamp = (value) => {
	  const date = value instanceof Date ? value : new Date(value);
	  if (Number.isNaN(date.getTime())) return "Invalid Date";
	  const diff = Date.now() - date.getTime();
	  if (diff < 60000) return "Just now";
	  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
	  const today = new Date();
	  if (date.toDateString() === today.toDateString()) return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
	  return date.toLocaleString("en-US", {
		month: "short",
		day: "2-digit",
		hour: "numeric",
		minute: "2-digit",
	  });
	};

	getTimestampLabel = (note) => {
	  if (!note) return "";
	  const rawTimestamp = note.updated_at || note.created_at || note.timestampISO || note.timestamp || note.createdAt || note.date;
	  if (!rawTimestamp) return "";
	  const formatted = this.formatTimestamp(rawTimestamp);
	  if (note.Edited_attempt > 0) return `Edited ${formatted}`;
	  return formatted;
	};

	getTimestampTitle = (note) => {
	  if (!note) return "";
	  const rawTimestamp = note.updated_at || note.created_at || note.timestampISO || note.timestamp || note.createdAt || note.date;
	  if (!rawTimestamp) return "";
	  const date = new Date(rawTimestamp);
	  if (Number.isNaN(date.getTime())) return "";
	  return date.toLocaleString("en-US", {
		month: "short",
		day: "2-digit",
		year: "numeric",
		hour: "numeric",
		minute: "2-digit",
	  });
	};

	//Kiran-5958-Added below code for internal campaign notes
	openNotesModal = () => {
	  const campIDFromState = this.state.campID && String(this.state.campID).trim();
	  const campIDFromProps = this.props.location && this.props.location.state && this.props.location.state.campID && String(this.props.location.state.campID).trim();
	  const campIDFromSession = sessionStorage.getItem("campID") && String(sessionStorage.getItem("campID")).trim();
	  const campID = campIDFromState || campIDFromProps || campIDFromSession;

	  if (!campID) {
		alert("Campaign ID is not available.");
		return;
	  }

	  this.setState({ campID }, () => {
		const isOpening = !this.state.showNotesModal;
		this.setState(
			(prevState) => ({ showNotesModal: !prevState.showNotesModal }),
			() => {
				if (isOpening) {
					this.getCampaignNotes();
				}
			}
		);
	  });
	};

	closeNotesModal = () => {
	  this.setState({ showNotesModal: false });
	};

	getCampaignNotes = async () => {
	  const campID = String(this.state.campID).trim();
	  if (!campID) return;
	  try {
		const response = await fetch("publisher/campaignInternalNotes", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({ action: "fetch", campaign_id: campID }),
		});
		const data = await response.json();
		console.log("Notes response:", data);
		if (data.success) {
		  this.setState({ campaignNotesHistory: data.result || [] });
		}
	  } catch (err) {
		console.error("Error fetching notes:", err);
	  }
	};

	handleNotesChange = (event) => {
	  this.setState({ campaignNotes: event.target.value });
	};

	handleSendNotes = async () => {
	  const { campaignNotes, campID } = this.state;
	  if (!campaignNotes.trim()) return;
	  try {
		const response = await fetch("publisher/campaignInternalNotes", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({ action: "add", campaign_id: campID, notes: campaignNotes }),
		});
		const result = await response.json();
		if (result.success) {
		  this.setState({ campaignNotes: "" });
		  this.getCampaignNotes();
		}
	  } catch (err) {
		console.error("Error sending notes:", err);
	  }
	};

	handleEditNote = (noteId, noteMessage = "") => {
	  this.setState({ editingNoteId: noteId, editingNoteText: noteMessage });
	};

	handleEditNoteSave = async (noteId) => {
	  const { editingNoteText, campID } = this.state;
	  if (!editingNoteText.trim()) return;
	  try {
		const response = await fetch("publisher/campaignInternalNotes", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({ action: "edit", note_id: noteId, campaign_id: campID, notes: editingNoteText }),
		});
		const result = await response.json();
		if (result.success) {
		  this.setState({ editingNoteId: null, editingNoteText: "" });
		  this.getCampaignNotes();
		}
	  } catch (err) {
		console.error("Error editing note:", err);
	  }
	};

	handleDeleteNote = async (noteId) => {
	  const { campID } = this.state;
	  try {
		const response = await fetch("publisher/campaignInternalNotes", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({ action: "delete", note_id: noteId, campaign_id: campID }),
		});
		const result = await response.json();
		if (result.success) {
		  this.getCampaignNotes();
		}
	  } catch (err) {
		console.error("Error deleting note:", err);
	  }
	};
	handleBackButtonToDashboard(e) {
		////shivani-task 3105-Added condition by parsing key to nevigate user on correct url according to conditions.////
		e.preventDefault();

		
		//var parsed = queryString.parse(this.props.location.search);
			//Sonali-3945-VAPT-accessing parameters from location.state

		var key = this.state.key;
		var campID = this.state.campID; //sandeep-task-3095-added URL parameter campID
		var parentCampID = this.state.parentCampID; //sandeep-task-3095-added URL parameter parentCampID
		var reallocationID = this.state.reallocationID;
		//shivani-task 3204 - passed this key to url for camp spec page back button when user will redirected from publisherDeliverLead .
		var key3 = this.state.leadkey;
		this.setState({
			campID: campID,
			parentCampID: parentCampID,
			reallocationID: reallocationID,
			key3: key3,
		});

		// Anshul-5907: added to go back to publisherInternalReviewLead for pc-tm role
		if (this.props.auth.user.role === "PC-TM") {
			this.props.history.push("/publisherInternalReviewLead", {
				pID: this.props.auth.user.id,
			});
		} else if (key === "Assign" || key === "Counter") {
			this.props.history.push("/newPublisherDashboard"); //sonali-task-3945-replace query params
		}
		//shivani-task 3204 - added this url for camp spec page back button when user will redirected from publisherDeliverLead .
		else if (key3 === "lead") {
			this.props.history.push("/publisherDeliverLead",{campID:campID,parentCampID:parentCampID,reallocationID:reallocationID}); //karan-task-3717-replace query params

			// window.location.href =
			// 	"/publisherDeliverLead?campID=" +
			// 	campID +
			// 	"&parentCampID=" +
			// 	parentCampID +
			// 	"&reallocationID=" +
			// 	reallocationID;
		} else {
			this.props.history.push("/publisherCampaignList"); //karan-task-3717-replace query params
		}
	}

	/**
	 * @author Sandeep Dhawale
	 * @param  Description handle the publisherDeliverLead
	 * @return Description return  onclick it redirect to publisherDeliverLead
	 */

	handleLeadUpload(e) {
		//var parsed = queryString.parse(this.props.location.search);
		var campID = this.props.location.state.campID; //sandeep-task-3064-added URL parameter campID
		var parentCampID = this.props.location.state.parentCampID; //sandeep-task-3064-added URL parameter parentCampID
		var reallocationID = this.props.location.state.reallocationID; //sandeep-task-3064-added URL parameter reallocationID

		this.props.history.push("/publisherDeliverLead",{campID:campID,parentCampID:parentCampID,reallocationID:reallocationID}); //sonali-task-3716-replace query params

		// window.location.href =
		// 	"/publisherDeliverLead?campID=" +
		// 	campID +
		// 	"&parentCampID=" +
		// 	parentCampID +
		// 	"&reallocationID=" +
		// 	reallocationID;
	}

	/**
	 * @author Somnath Keswad
	 * @param  Description handle the Campaign Modal Details PDF
	 * @return Description return All steps campaign Details PDF
	 */
	handleFileDownload(e) {
		var campID = this.state.campID;
		// let downloadFileName = campID + "-CampaignSpecification.pdf";
		// var countryName = countryArray.join("");
		//var jobLevel = jobLevelArray.join("");
		//var companyRevenue = companyRevenueArray.join("");
		// var jobFunction = jobFunctionArray.join("");
		// var employeeSize = employeeSizeArray.join("");
		// var abmFileName = abmFile.join("");
		// var suppressionFileName = suppressionFile.join("");
		// var execlusionFileName = execlusionFile.join("");
		// var otherFileName = otherFile.join(""); //kiran-4746-removing console warning-no used
 
		/**
		 * @author Narendra Phadke
		 * @param  Description handle the Campaign related Files
		 * @return Description return All The File Download in Zip
		 */

		var formData = new FormData();
		formData.append("campID", campID);
		//const {  user } = this.props.auth;
		//var userID = user.id;//kiran-4746-removing console warning-no used

		//This api is used for dynamic pdf genration
		//sonali-3945-removing userID from follwing route call
		fetch(
			"publisher/downloadDynamicPDFCampaignDetailsforPublisher?campID=" +
				campID +
				"&campName=" +
				this.state.campaignName +
				"&cancelTab=" +
				this.state.cancelKey//sonali-4113-replaced cancelTab by cancelKey
		)
			.then((r) => r.blob())
			.then((downloadFiles) => this.setState({ downloadFiles: downloadFiles }))
			.then(this.handlePDFFileShowDownload);
			//Sonali-3945-removing userID from following route call
		fetch(
			"publisher/downloadCampaignDetails?campID=" +
				campID +
				"&campName=" +
				encodeURIComponent(this.state.campaignName) //Rutuja task 5636 passing campaign name by doing ecodeURI
		)
			.then((r) => r.blob())
			.then((downloadFiles) => this.setState({ downloadFiles: downloadFiles }))
			.then(this.handleFileShowDownload);
	} /** End of handle File Download */

	handleFileShowDownload(blob) {
		// It is necessary to create a new blob object with mime-type explicitly set
		// otherwise only Chrome works like it should
		// Chaitanya-5540-Changed this.state.parentCampID to this.state.campID

		let zipFileName =
			this.state.campID +
			"-" +
			this.state.reallocationID +
			"-" +
			this.state.campaignName +
			".zip";

		var newBlob = new Blob([this.state.downloadFiles], {
			type: "application/zip",
		});
		// IE doesn't allow using a blob object directly as link href
		// instead it is necessary to use msSaveOrOpenBlob
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(newBlob);
			return;
		}

		// For other browsers:
		// Create a link pointing to the ObjectURL containing the blob.
		const data = window.URL.createObjectURL(newBlob);
		var link = document.createElement("a");
		link.href = data;
		link.download = zipFileName;
		link.click();
	}

	/**
	 * @author Narendra Phadke
	 * @param  Description handle the Campaign Specification Dynamic PDF Details
	 * @return Description return pdf file campaign details
	 */
	handlePDFFileShowDownload(blob) {
		// It is necessary to create a new blob object with mime-type explicitly set
		// otherwise only Chrome works like it should
		// Chaitanya-5540--Changed this.state.parentCampID to this.state.campID

		let zipFileDownloadName =
			this.state.campID +
			"-" +
			this.state.reallocationID +
			"-" +
			this.state.campaignName +
			"-Campaign Specification.pdf";

		var newBlob = new Blob([this.state.downloadFiles], {
			type: "application/pdf",
		});

		// IE doesn't allow using a blob object directly as link href
		// instead it is necessary to use msSaveOrOpenBlob
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(newBlob);
			return;
		}

		// For other browsers:
		// Create a link pointing to the ObjectURL containing the blob.
		const data = window.URL.createObjectURL(newBlob);
		var link = document.createElement("a");
		link.href = data;
		link.download = zipFileDownloadName;
		link.click();
	}

	render() {
	//Sanjana Godbole-3728-VAPT--publisher side--Home--URL links And Routes-FE
	//Sonali-4032-getting parameters from session strorage
	if(this.props.location.state!==undefined ){
		this.state.campID=this.props.location.state.campID;
		this.state.parentCampID=this.props.location.state.parentCampID
		this.state.reallocationID=this.props.location.state.reallocationID;
		}
		else if (sessionStorage.getItem("campID") !== undefined) {
		  this.state.campID = sessionStorage.getItem("campID");
		  this.state.parentCampID = sessionStorage.getItem("parentCampID");
		  this.state.reallocationID = sessionStorage.getItem("reallocationID");
		}
	


		const { user } = this.props.auth; //kiran-4746-removing console warning-no used

		return (
			<div>
				<PublisherNavigation />
				{/* Nilesh-4839 Add display, flexDirection,flex, backgroundColor, paddingTop, position, top and zIndex in below div */}
				<div style={{ paddingTop: "110px", display: "flex", flexDirection: "column" }}>
					<div class="container-fluid fixed-top"style={{
						flex: "0 0 auto",
						backgroundColor:"rgb(245 245 245)",
						paddingTop: "10px",
						position: "sticky",
						top: "79px",
						zIndex: "999"
					}}>
						<div class="row" style={{ paddingBottom: "20px" }}>
							<div class="col-lg-4">
								{/*sunita-task-3104-changed as per alignment */}
								{/* kiran-4746-removing console warning-added "#/" */}
								<a href="#/" onClick={this.handleBackButtonToDashboard}>
									<FaArrowAltCircleLeft
										size={32}
										style={{ float: "left", color: "#056eb8" }}
										title={user.role === "PC-TM" ? "" : "Back to publisherCampaignList"} //*Anshul-5907: showing title conditionally
									/>
								</a>{" "}
								{/* //shivani-task 3105-added onClick function to nevigate on correct url. */}
							</div>

							<div class="col-lg-4">
								{/* snehal-task-3561-Reff(3428)----spec and cust mapping format issue  */}
								<label
									style={{
										color: "#193D8F",
										fontSize: "28px",
										paddingLeft: "100px",
										fontWeight: "500",
										fontFamily: "roboto",
										//paddingLeft: "120px", {/* kiran-4746-removing console warning-remove duplicate attribute */}
									}}>
									Campaign ID:{this.state.campID}
									{/* Chaitanya-5540-Changed this.state.parentCampID to this.state.campID*/}
								</label>
							</div>

						<div class="col-lg-4" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px" }}>
							{/* kiran-4746-removing console warning-changed == to === */}
								{this.state.tab === "Active" ? (
									// Sandeep-task-3266-added code to disable Lead Upload button for PQA
									user.role !== "PQA" ? (
									<div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
											<React.Fragment>
												<span className="internal-notes-icon-wrapper" style={{ display: "inline-flex", alignItems: "center", marginRight: "10px" }}>
													<Badge
														count={this.state.campaignNotesHistory.length > 10 ? "10+" : this.state.campaignNotesHistory.length}
														overflowCount={10}
														offset={[0, -6]}
														style={{ backgroundColor: "#f5222d", color: "white", borderRadius: "50%", fontSize: "12px" }}
													>
														<img
															src="/notes.png"
															alt="Notes"
															style={{ width: "27px", height: "27px", cursor: "pointer",marginBottom:'24px' }}
															onClick={this.openNotesModal}
														/>
													</Badge>
												</span>
												<button
													type="button"
													class="btn add-button"
													id="cmd"
													onClick={this.handleLeadUpload}
													disabled={this.state.isLeadUploadButtonDisable}>
													Lead Upload
												</button>
											</React.Fragment>
										</div>
									) : (
									<div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
											<React.Fragment>
												<span className="internal-notes-icon-wrapper" style={{ display: "inline-flex", alignItems: "center", marginRight: "10px" }}>
													<Badge
														count={this.state.campaignNotesHistory.length > 10 ? "10+" : this.state.campaignNotesHistory.length}
														overflowCount={10}
														offset={[2, -39]}
														style={{ backgroundColor: "#f5222d", color: "white", borderRadius: "50%", fontSize: "12px" }}
													>
														<img
															src="/notes.png"
															alt="Notes"
															style={{ width: "27px", height: "27px", cursor: "pointer",marginTop:'-30px' }}
															onClick={this.openNotesModal}
														/>
													</Badge>
												</span>
												<button
													type="button"
													class="btn add-button"
													id="cmd"
													onClick={this.handleLeadUpload}
													disabled>
													Lead Upload
												</button>
											</React.Fragment>
										</div>
									)
								) : (
									""
								)}
								{/* Added notes icon for PC, PQA, PNC, PC-TM roles when tab is not Active to ensure consistent visibility */}
								{((this.props.auth.user.role && (this.props.auth.user.role.includes("PC") || this.props.auth.user.role === "PQA")) && this.state.tab !== "Active") && (
									<span className="internal-notes-icon-wrapper" style={{ display: "inline-flex", alignItems: "center", marginRight: "10px" }}>
										<Badge
											count={this.state.campaignNotesHistory.length > 10 ? "10+" : this.state.campaignNotesHistory.length}
											overflowCount={10}
											offset={[0, -6]}
											style={{ backgroundColor: "#f5222d", color: "white", borderRadius: "50%", fontSize: "12px" }}
										>
											<img
												src="/notes.png"
												alt="Notes"
												style={{ width: "27px", height: "27px", cursor: "pointer",marginBottom:'27px' }}
												onClick={this.openNotesModal}
											/>
										</Badge>
									</span>
								)}								{/* kiran-4746-removing console warning-changed == to === */}
								{this.state.tab === "Active" ? ( //sunita-task-3104-used when it gets tab active as per that download button will show
									<div class="col-lg-3">
										<button
											type="button"
											class="btn add-button"
											id="cmd"
											onClick={this.handleFileDownload}
											style={{ marginLeft: "5px" }}>
											Download
										</button>
									</div>
								) : (
									<button
										type="button"
										class="btn add-button"
										id="cmd"
										onClick={this.handleFileDownload}
										style={{ float: "right" }}>
										Download
									</button>
								)}
							</div>
						</div>
					</div>

{/* Sonali-4113-passing all keys to details page */}
					<CampaignSpecificationPublisherDashboardDetails
						greeting={this.state.campID}
						parentCampID={this.state.parentCampID}
						cancelKey={this.state.cancelKey}
						leadkey={this.state.parentCampID}
						tab={this.state.tab}
						key3={this.state.key3}
					/>

					<div class="container-fluid" style={{ paddingBottom: "70px" }}>
						<div class="row">
							<div class="col-lg-5" style={{ paddingTop: "20px" }}>
								<button
									type="button"
									class="btn add-button"
									id="cmd"
									style={{ float: "left" }}
									onClick={this.handleFileDownload}>
									Download
								</button>
							</div>
						</div>
					</div>
				</div>
					{this.state.showNotesModal && (
					<div ref={this.notesPanelRef} className="internal-notes-wrapper">
						<div className="internal-notes-panel">
							<button
								type="button"
								className="internal-notes-close"
								onClick={this.closeNotesModal}
								aria-label="Close internal campaign notes"
							>
								<span aria-hidden="true">&times;</span>
							</button>
							<div className="internal-notes-title">
								<div className="internal-notes-heading">Internal Campaign Notes</div>
								<div className="internal-notes-subtitle">Campaign ID : <span>{this.state.campID || "--"}</span></div>
							</div>
							<div className="internal-notes-body" ref={this.notesBodyRef}>
								{this.state.campaignNotesHistory.length > 0 ? (
									this.state.campaignNotesHistory.slice().reverse().map((note) => {
										const { name, initials } = this.resolveNoteUserMeta(note);
										const timestampLabel = this.getTimestampLabel(note);
										const timestampTitle = this.getTimestampTitle(note);
										const isJustNow = timestampLabel === "Just now";
										const isEdited = note.Edited_attempt > 0;
										return (
											<div className="internal-note-item" key={note.note_id || note.id || note.created_at}>
												<div className="internal-note-avatar">{initials}</div>
												<div className="internal-note-content">
													<div className="internal-note-header">
														<div className="internal-note-meta">
															<span className="internal-note-user">{name}</span>
															<span className={`internal-note-time ${isJustNow ? "internal-note-time-new" : ""} ${isEdited ? "internal-note-time-edited" : ""}`} title={timestampTitle}>
																{timestampLabel}{isEdited}
															</span>
														</div>
													</div>
												<div className="internal-note-message">{note.message}</div>
											</div>
										</div>
									);
									})
								) : (
									<div className="internal-notes-empty"><p>No notes yet.</p></div>
								)}
							</div>
						</div>
					</div>
				)}
				<Footer />
			</div>
		);
	}
}

/**
 * @author Narendra Phadke
 * @param  Description handle the login authentication
 * @return Description return All details of authentication
 */
CampaignSpecificationPublisherDashboard.propTypes = {
	logoutUser: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
	auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(
	withRouter(CampaignSpecificationPublisherDashboard)
);
